import { render, staticRenderFns } from "./MaterialCodeModal.vue?vue&type=template&id=53dae68e&scoped=true&"
import script from "./MaterialCodeModal.vue?vue&type=script&lang=js&"
export * from "./MaterialCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCodeModal.vue?vue&type=style&index=0&id=53dae68e&prod&lang=scss&scoped=true&"
import style1 from "./MaterialCodeModal.vue?vue&type=style&index=1&id=53dae68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dae68e",
  null
  
)

export default component.exports